import React, { useCallback, useEffect, useState } from 'react';

import { useEvent } from '../../../../data/hooks/eventHooks';
import { useLocale } from '../../../../data/hooks/i18nHooks';
import Icon from '../../../elements/icons/Icon';
import Link from '../../../elements/Link';
import NotificationIcon from '../../../elements/NotificationIcon';
import TimeFromNow from '../../../elements/TimeFromNow/TimeFromNow';
import styles from './NotificationDialog.module.scss';

const NotificationDialog = (props) => {
    const { notification } = props,
        event = useEvent(),
        { sent_on } = notification,
        locale = useLocale(),
        content = notification.content?.message?.[locale] || notification.content?.message?.en || notification.content?.message,
        notificationEvent = useEvent(notification.content?.data?.eventId),
        targetRoute = ['notifications', notification.id],
        [ready, setReady] = useState(false);

    if (event) {
        targetRoute.unshift('events', event.id);
    }
    targetRoute.unshift('');

    useEffect(() => setReady(true), []);

    const handleClose = useCallback(() => {
        app.api.notifications.markRead(notification.id);
    }, [notification]);

    const handleNotificationOpened = useCallback(() => {
        app.store.dispatch(app.actions.ui.sidePanel.maximize(false));
        handleClose();
    }, [handleClose]);

    return (
        <div className={[styles.NotificationDialog, ready ? '' : styles.hidden].join(' ')}>
            <NotificationIcon notification={notification} color="#82d2f0" />
            <button type="button" className={styles.close} onClick={handleClose}>
                <Icon src="/img/reject_icon.png" color="#a9a9a9" />
            </button>
            <Link className={styles.content} href={targetRoute.join('/')} onClick={handleNotificationOpened}>
                {content}
            </Link>
            <div className={styles.details}>
                <div className={styles.timestamp}>
                    <TimeFromNow>{sent_on}</TimeFromNow>
                </div>
                {event?.id != notificationEvent?.id ? <div className={styles.event}>{notificationEvent?.name}</div> : null}
            </div>
        </div>
    );
};

export default NotificationDialog;
